Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _airbnbPropTypes = require('airbnb-prop-types');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _direction = require('react-with-direction/dist/proptypes/direction');

var _direction2 = _interopRequireDefault(_direction);

var _withStyles = require('../themes/withStyles');

var _Shimmer = require('./Shimmer');

var _Shimmer2 = _interopRequireDefault(_Shimmer);

var _withLoading = require('./withLoading');

var _withLoading2 = _interopRequireDefault(_withLoading);

var _idProp = require('../utils/propTypes/idProp');

var _idProp2 = _interopRequireDefault(_idProp);

var _requiredUnless = require('../utils/propTypes/requiredUnless');

var _requiredUnless2 = _interopRequireDefault(_requiredUnless);

var _textAlignPosition = require('../constants/textAlignPosition');

var _textAlignPosition2 = _interopRequireDefault(_textAlignPosition);

var _conditionallyRestrictedProp = require('../utils/propTypes/conditionallyRestrictedProp');

var _conditionallyRestrictedProp2 = _interopRequireDefault(_conditionallyRestrictedProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var sizingProp = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small', 'reduced', 'large', 'short', 'largeShort', 'tall', 'largeTall', 'microWide');
var emphasisProp = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('bold', 'light');
var colorProp = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('muted', 'disabled', 'inverse');

var noInlineWithTextAlign = (0, _conditionallyRestrictedProp2['default'])({
  propType: _propTypes2['default'].bool,
  restrictedCondition: function () {
    function restrictedCondition(_ref) {
      var inline = _ref.inline,
          textAlign = _ref.textAlign;
      return !!textAlign && inline;
    }

    return restrictedCondition;
  }(),
  restrictedMessage: function () {
    function restrictedMessage(props, propName, componentName) {
      return String(componentName) + ': ' + String(propName) + ' is forbidden to be true when textAlign is set';
    }

    return restrictedMessage;
  }()
});

var noTextAlignWithInline = (0, _conditionallyRestrictedProp2['default'])({
  propType: _textAlignPosition.textAlignPositionProp,
  restrictedCondition: function () {
    function restrictedCondition(_ref2) {
      var inline = _ref2.inline;
      return inline;
    }

    return restrictedCondition;
  }(),
  restrictedMessage: function () {
    function restrictedMessage(props, propName, componentName) {
      return String(componentName) + ': ' + String(propName) + ' is forbidden for inline text';
    }

    return restrictedMessage;
  }()
});

var propTypes = exports.propTypes = {
  id: _idProp2['default'],

  // Sizing:
  micro: sizingProp,
  small: sizingProp,
  reduced: sizingProp,
  large: sizingProp,

  short: sizingProp,
  largeShort: sizingProp,

  tall: sizingProp,
  largeTall: sizingProp,

  microWide: sizingProp,

  bold: emphasisProp,
  light: emphasisProp,

  inverse: colorProp,
  muted: colorProp,
  disabled: colorProp,

  dir: _direction2['default'], // use the `getTextDirection` util to set this prop
  inline: noInlineWithTextAlign,
  textAlign: noTextAlignWithInline,
  children: (0, _requiredUnless2['default'])('isLoading', _propTypes2['default'].node)
};

var finalPropTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, _withLoading.withLoadingPropTypes, propTypes));

var defaultProps = {
  id: undefined,

  micro: false,
  small: false,
  reduced: false,
  large: false,

  bold: false,
  light: false,

  inverse: false,
  muted: false,
  disabled: false,

  dir: undefined,
  inline: false,
  textAlign: undefined
};

function getTag(inline, micro, isLoading) {
  if (inline) {
    return 'span';
  }
  if (micro) {
    return 'small';
  }
  if (isLoading) {
    return 'div';
  }
  return 'div';
}

function getSizeStyle(styles, micro, small, reduced, large, short, largeShort, tall, largeTall, microWide) {
  if (micro) {
    return styles.size_micro;
  }
  if (small) {
    return styles.size_small;
  }
  if (reduced) {
    return styles.size_reduced;
  }
  if (large) {
    return styles.size_large;
  }
  if (short) {
    return styles.size_regularShort;
  }
  if (largeShort) {
    return styles.size_largeShort;
  }
  if (tall) {
    return styles.size_regularTall;
  }
  if (largeTall) {
    return styles.size_largeTall;
  }
  if (microWide) {
    return styles.size_microWide;
  }

  return styles.size_regular;
}

var SHIMMER = _react2['default'].createElement(_Shimmer2['default'], null);

function Text(_ref3) {
  var css = _ref3.css,
      bold = _ref3.bold,
      children = _ref3.children,
      dir = _ref3.dir,
      id = _ref3.id,
      inline = _ref3.inline,
      inverse = _ref3.inverse,
      light = _ref3.light,
      micro = _ref3.micro,
      muted = _ref3.muted,
      disabled = _ref3.disabled,
      small = _ref3.small,
      reduced = _ref3.reduced,
      large = _ref3.large,
      short = _ref3.short,
      largeShort = _ref3.largeShort,
      tall = _ref3.tall,
      largeTall = _ref3.largeTall,
      microWide = _ref3.microWide,
      styles = _ref3.styles,
      isLoading = _ref3.isLoading,
      textAlign = _ref3.textAlign;

  var Tag = getTag(inline, micro || microWide, isLoading);
  var sizeStyle = getSizeStyle(styles, micro, small, reduced, large, short, largeShort, tall, largeTall, microWide);

  return _react2['default'].createElement(
    Tag,
    _extends({
      dir: dir,
      id: id
    }, css(styles.text, sizeStyle, bold && styles.weight_bold, light && styles.weight_light, inverse && styles.color_inverse, muted && large && styles.color_mutedLarge, muted && !large && styles.color_muted, disabled && styles.color_disabled, inline && styles.inline, textAlign === _textAlignPosition2['default'].START && styles.align_start, textAlign === _textAlignPosition2['default'].END && styles.align_end, textAlign === _textAlignPosition2['default'].CENTER && styles.align_center, textAlign === _textAlignPosition2['default'].JUSTIFY && styles.align_justify)),
    isLoading ? SHIMMER : children
  );
}

Text.componentCategory = 'Core';
Text.displayName = 'Text';
Text.propTypes = finalPropTypes;
Text.defaultProps = defaultProps;

exports['default'] = (0, _withLoading2['default'])((0, _withStyles.withStyles)(function (_ref4) {
  var color = _ref4.color,
      font = _ref4.font;
  return {
    text: Object.assign({}, font.book, {
      color: color.core.hof,
      fontFamily: font.FONT_FAMILY,

      // Override text margins defined by O2 or Bootstrap
      margin: 0,
      wordWrap: 'break-word'
    }),

    size_micro: Object.assign({}, font.textMicro),

    size_small: Object.assign({}, font.textSmall),

    size_reduced: Object.assign({
      fontSize: 17,
      lineHeight: '22px',
      letterSpacing: 0.2
    }, font.textReduced),

    size_regular: Object.assign({}, font.textRegular),

    size_large: Object.assign({}, font.textLarge),

    size_regularShort: Object.assign({}, font.textRegularShort),

    size_largeShort: Object.assign({}, font.textLargeShort),

    size_regularTall: Object.assign({}, font.textRegularTall),

    size_largeTall: Object.assign({}, font.textLargeTall),

    size_microWide: Object.assign({}, font.textMicroWide),

    color_inverse: {
      color: color.white
    },

    color_muted: {
      color: color.textMuted,

      '@media print': {
        color: color.printOverrides.textMuted
      }
    },

    color_mutedLarge: {
      color: color.textMutedLarge,

      '@media print': {
        color: color.printOverrides.textMutedLarge
      }
    },

    color_disabled: {
      color: color.textDisabled
    },

    weight_bold: Object.assign({}, font.bold),

    weight_light: Object.assign({}, font.light),

    inline: {
      display: 'inline'
    },

    align_start: {
      textAlign: 'left'
    },

    align_center: {
      textAlign: 'center'
    },

    align_end: {
      textAlign: 'right'
    },

    align_justify: {
      textAlign: 'justify'
    }
  };
}, { pureComponent: true })(Text));


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Text.js
// module id = 16
// module chunks = 168707334958949